<template>
  <AModal modal-class="d-book-review-book text-black-base">
    <div class="overlay" />

    <div class="modal-content">
      <div class="modal-header">
        <h4>Are you sure?</h4>
        <a
          class="button button-yellow button-icon button-close-white button-close-modal"
          @click="dismiss"
        />
      </div>

      <div
        class="modal-body loadable"
        :class="{ 'loading': vm.isProcessing }"
      >
        <div
          v-if="vm.isProcessing"
          class="loading-content"
        >
          <DuiLoadingIndicator size="lg" />
          <p class="space-top-2em">
            Saving...
          </p>
        </div>

        <div class="loaded-content">
          <p>
            To get full access to <i>{{ book.title }}</i>, please
            confirm that you can provide the author with a fair review before
            their book launches on {{ book.launch_date }}.
          </p>

          <form>
            <div class="form-group">
              <DuiCheckbox
                v-model="vm.isAgreed"
                :disabled="vm.isProcessing"
                label="Yes, I have enough time to review this book!"
                name="isAgreed"
                title="Yes, I have enough time to review this book!"
              />
            </div>

            <p class="space-bottom-2em">
              Once you have selected this book, it will be removed from our
              list of books available for review and added to your
              'Currently Reviewing' tab.
            </p>
            <p>– Happy reading! <span class="emoji">🤓</span></p>

            <div class="button-pair right space-top-4em">
              <button
                type="button"
                @click="dismiss"
              >
                Cancel
              </button>

              <button
                class="button-yellow"
                :disabled="!isFormValid"
                type="button"
                @click="submit"
              >
                Review
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </AModal>
</template>

<script>
import Vue from 'vue';

import AModal from '@d-components/a-modal/a-modal.vue';
import libraryService from '@d-services/library-service/library-service';
import URLS from '@d-shared/urls/urls';
import { getErrorMessage } from '@d-shared/utils/errors';
import Window from '@d-shared/utils/window';

export default {
  components: {
    AModal,
  },
  props: {
    book: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    vm: {
      isAgreed: false,
      isProcessing: false,
    },
  }),
  computed: {
    isFormValid() {
      return this.vm.isAgreed;
    },
  },
  mounted() {
    this.reset();
  },
  methods: {
    dismiss() {
      this.$emit('dismiss-review-book');
      this.reset();
    },
    reset() {
      this.$set(this.vm, 'isProcessing', false);
      this.$set(this.vm, 'isAgreed', false);
    },
    async submit() {
      if (!this.isFormValid) {
        return;
      }

      this.$set(this.vm, 'isProcessing', true);

      try {
        await libraryService.createReview(this.book.slug);
        libraryService.saveJustAddedBookForReview(this.book.slug);
        Window.goTo(URLS.app.library.currentlyReviewing);
      } catch (error) {
        Vue.duiNotificationManager.error(getErrorMessage(error));
        this.$set(this.vm, 'isProcessing', false);
      }
    },
  },
};
</script>
